module.exports = __webpack_public_path__ + "static/media/phone.f1a94f2a.svg";